// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { Note, Tag, Trip, Profile, NoteTags, Coordinates, ScaledImage } = initSchema(schema);

export {
  Note,
  Tag,
  Trip,
  Profile,
  NoteTags,
  Coordinates,
  ScaledImage
};